export const profile = {
  name: "Dr. Vijay P. Pandya",
  shortName: "Dr. Vijay Pandya",
  initials: "VP",
  title: "Healthcare Professional",
  tagline: "NABH Assessor & National Award Winner in Healthcare Quality",
  qualifications: "MBBS · MD (Community Medicine) · PG Diploma in Healthcare & Hospital Management",
  intro:
    "A dedicated medical professional with 20+ years of diversified leadership experience across hospital administration, medical college establishment, public health and quality assurance. Proven ability to build new systems, lead NABH accreditations and elevate healthcare delivery.",
  contact: {
    email: "drpandya2902@gmail.com",
    linkedin: "https://www.linkedin.com/in/dr-vijay-pandya-6b4602a9",
  },
  stats: [
    { value: "20+", label: "Years of Experience" },
    { value: "8+", label: "Hospitals & Medical Colleges Led" },
    { value: "12+", label: "National & State Awards" },
    { value: "1st", label: "Urban Health Centre in India NABH Accredited" },
  ],
};

export const about = {
  paragraphs: [
    "Dr. Vijay P. Pandya is a healthcare management leader offering diversified experience in hospital administration, facility management and the implementation of high-quality healthcare services. A decisive leader, he has repeatedly demonstrated the ability to introduce new systems and improve existing healthcare and social environments.",
    "He is an accredited NABH Assessor (since 2008) appointed by the National Accreditation Board for Hospitals, Government of India, and a National Award Winner in Healthcare Quality. His career spans greenfield and brownfield medical college projects, multi-superspeciality hospital leadership, and large-scale public health programmes.",
    "Adept at managing clinical and non-clinical departments, regulatory inspections (MCI/NMC), quality systems and stakeholder coordination, Dr. Pandya combines clinical insight with sharp administrative execution.",
  ],
  highlights: [
    "Associate Member, Quality Council of India (FM/WR/4359)",
    "NABH Assessor — Government of India (April 2008)",
    "National Award Winner in Healthcare Quality",
    "Nominated for PM Award for Excellence in Public Administration (2013)",
  ],
};

export const expertise = [
  {
    title: "Hospital Administration",
    desc: "End-to-end operations of multi-superspeciality and teaching hospitals — clinical, non-clinical, finance, HR and facility management.",
    icon: "Building2",
    span: "lg:col-span-2",
  },
  {
    title: "NABH Accreditation",
    desc: "Accredited NABH Assessor leading accreditation across hospitals, PHCs & urban health centres.",
    icon: "BadgeCheck",
    span: "",
  },
  {
    title: "Quality Assurance",
    desc: "National-award winning quality systems, infection control and patient safety frameworks.",
    icon: "ShieldCheck",
    span: "",
  },
  {
    title: "Medical College Establishment",
    desc: "Greenfield & brownfield medical college setup, NMC/MCI inspections and academic operations.",
    icon: "GraduationCap",
    span: "lg:col-span-2",
  },
  {
    title: "Public Health Programs",
    desc: "Disease control, nutrition missions, HIV/AIDS, malaria & epidemic response at district scale.",
    icon: "HeartPulse",
    span: "",
  },
  {
    title: "Healthcare Consultancy",
    desc: "Branding, business development, capacity building, fundraising & CSR for healthcare institutions.",
    icon: "Briefcase",
    span: "",
  },
];

export const experience = [
  {
    role: "CEO & Professor",
    org: "PSM Multi-Superspeciality Hospital & Swaminarayan Medical College, Kalol",
    period: "Dec 2023 – Nov 2025",
    detail: "400-bedded teaching hospital with superspeciality services and medical college.",
  },
  {
    role: "Chief Operating Officer & Professor",
    org: "SAL Institute of Medical Sciences & SAL Hospital, Ahmedabad",
    period: "Jan 2023 – Nov 2023",
    detail: "400-bedded teaching hospital with superspeciality services and medical college.",
  },
  {
    role: "Additional Dean (I/C MS) & Professor",
    org: "SAL Medical College & Hospital, Ahmedabad",
    period: "2022 – 2023",
    detail: "600-bed hospital and medical college with 150 MBBS seats.",
  },
  {
    role: "CEO & Associate Professor",
    org: "C.U. Shah Hospital & Medical College, Surendranagar",
    period: "Feb 2022 – Sep 2022",
    detail: "700-bedded teaching hospital & medical college.",
  },
  {
    role: "Assistant Dean & Dy. Medical Superintendent",
    org: "Nootan General Hospital, Visnagar, Mehsana",
    period: "Aug 2018 – Jan 2022",
    detail: "400-bedded teaching hospital & medical college.",
  },
  {
    role: "Assistant Dean & Assistant Professor",
    org: "Banas Medical College & Hospital, Palanpur",
    period: "Oct 2017 – Aug 2018",
    detail: "Medical college establishment, NMC inspections & academic operations.",
  },
  {
    role: "Chief Medical Officer (Class–I)",
    org: "Health Department, Rajkot Municipal Corporation",
    period: "Mar 2014 – Apr 2017",
    detail: "Management of medical services across 20 health centres and city health programmes.",
  },
  {
    role: "District Medical Officer (Quality Assurance)",
    org: "Health Department, District Panchayat, Ahmedabad",
    period: "2008 – 2014",
    detail: "Policy, monitoring & evaluation of health services and quality assurance.",
  },
];

export const education = [
  { degree: "PG Diploma in Healthcare & Hospital Management", school: "NIMS University, Jaipur", year: "2012" },
  { degree: "MD (Community Medicine)", school: "M.P. Shah Medical College, Jamnagar", year: "2003" },
  { degree: "MBBS", school: "M.P. Shah Medical College, Jamnagar", year: "1999" },
];

export const awards = [
  { title: "Times Education Icon Award", sub: "Excellence in Patient Care & Medical Education", year: "2025" },
  { title: "Excellence in Patient Communication", sub: "AHMP India Summit Award", year: "2025" },
  { title: "National Award for Best Performance in Healthcare", sub: "HOCON, Ahmedabad", year: "2024" },
  { title: "D.L. Shah National Award — QCI", sub: "Implementation of Food Safety Act, Rajkot", year: "2016" },
  { title: "Kayakalp Award", sub: "Govt. of Gujarat — Best Practice in Healthcare, Rajkot", year: "2016" },
  { title: "Quality Mark National Award", sub: "Best Practice in Healthcare, Rajkot City", year: "2016" },
  { title: "Excellence in Healthcare", sub: "Indian Achievers Forum, Dubai", year: "2018" },
  { title: "QCI National Award", sub: "Malnutrition-Free City Campaign, Rajkot", year: "2015" },
  { title: "QCI National Award", sub: "Nutrition Mission against Child Malnutrition, Ahmedabad", year: "2013" },
];

export const achievements = [
  "First Urban Health Centre in India to achieve NABH Accreditation (Nana Mawa, Rajkot — 2015).",
  "Third Primary Health Centre in India to achieve NABH Accreditation (Jetalpur PHC, Ahmedabad — 2011).",
  "Successful management of a Guinness World Record event — Prenatal Yoga with 1500+ participants (Rajkot, 2016).",
  "Nominated for the Prime Minister's Award for Excellence in Public Administration (2013).",
  "Led full NABH accreditation at HCG Cancer Centre, Ahmedabad (2017) and Sola Civil Hospital (2009-10).",
  "Appreciated by Hon. Chief Minister for Malaria Control achievement in Ahmedabad District (2012).",
];

export const significantAchievements = [
  {
    year: "2025",
    title: "Excellence in Patient Communication",
    body: "AHMP India Summit — Healthcare Marketing Maestros Award",
    desc: "Honoured at the AHMP India Summit 2025, Ahmedabad, for excellence in patient communication on behalf of PSM Multi-Superspeciality Hospital & Swaminarayan Medical College.",
    featured: true,
  },
  {
    year: "2024",
    title: "National Award for Best Performance in Healthcare",
    body: "HOCON, Ahmedabad — Presented by the Health Minister",
    desc: "PSM Hospital felicitated for best performance in healthcare; award received by Dr. Pandya as CEO from the Hon. Health Minister.",
    featured: true,
  },
  {
    year: "2023–24",
    title: "Recognition for Best Practice in Medical Services",
    body: "Government of Gujarat — District Administration, Gandhinagar",
    desc: "Certificate of appreciation by the Government of Gujarat acknowledging outstanding work in the medical field.",
    featured: true,
  },
  {
    year: "2015",
    title: "First Urban Health Centre in India — NABH Accredited",
    body: "National Accreditation Board for Hospitals (NABH)",
    desc: "Under his leadership the Urban Health Centre, Rajkot Municipal Corporation became the first of its kind in India to achieve NABH accreditation. Felicitated by the Hon. Health Minister.",
    featured: true,
  },
  {
    year: "2008",
    title: "NABH Assessor — Government of India",
    body: "National Accreditation Board for Hospitals & Healthcare Providers",
    desc: "Completed the NABH Assessor course and examination (April 2008), qualifying to assess hospitals against NABH accreditation standards.",
  },
  {
    year: "2018",
    title: "Excellence in Healthcare",
    body: "Indian Achievers Forum — 12th International Summit, Dubai",
    desc: "Internationally recognised for excellence in healthcare at the Indian Achievers Forum, Dubai.",
  },
  {
    year: "2016",
    title: "Guinness World Record Event Management",
    body: "Prenatal Yoga, BAPS Temple, Rajkot — 1,546 participants",
    desc: "Successfully managed a Guinness World Record-breaking prenatal yoga event with 1,546 participants on 21 June 2016.",
  },
  {
    year: "2016",
    title: "D.L. Shah National Award — Food Safety Act",
    body: "Quality Council of India — 11th National Quality Conclave",
    desc: "National recognition for best practice in implementation of the Food Safety Act in Rajkot City.",
  },
  {
    year: "2016",
    title: "Quality Mark National Award — Person of the Year",
    body: "Quality Mark Trust, Gujarat — Public Health Care",
    desc: "Winner in the Public Health Care category; recognised as 'Person of the Year' and congratulated by the Divya Bhaskar Group.",
  },
  {
    year: "2016",
    title: "Kayakalp Award",
    body: "Government of Gujarat",
    desc: "State recognition for best practice in healthcare in Rajkot City.",
  },
  {
    year: "2015",
    title: "QCI National Award — Malnutrition-Free City Campaign",
    body: "Quality Council of India (with WHO & Govt. of India)",
    desc: "Certificate of Merit for the 'Malnutrition-Free Rajkot' campaign reducing child malnutrition.",
  },
  {
    year: "2013",
    title: "QCI National Award — Nutrition Mission",
    body: "Quality Council of India — D.L. Shah Award",
    desc: "National award for the campaign against malnutrition in rural children of Ahmedabad District under the Gujarat Nutrition Mission.",
  },
  {
    year: "2012",
    title: "Malaria Control Achievement",
    body: "Appreciated by Hon. Chief Minister Shri Narendra Modi",
    desc: "Recognised for successful malaria control in rural areas of Ahmedabad District as District Quality Assurance Officer.",
  },
  {
    year: "2011",
    title: "Third PHC in India — NABH Accredited",
    body: "PHC Jetalpur, Ahmedabad — District Panchayat",
    desc: "Valuable contribution to NABH accreditation of PHC Jetalpur, only the third Primary Health Centre in India to achieve it.",
  },
  {
    year: "2011",
    title: "Best Quality Assurance Medical Officer",
    body: "Health Department, Govt. of Gujarat",
    desc: "Recognised as an outstanding contributor in healthcare quality at the National Conference on Best Practices in Healthcare Delivery.",
  },
  {
    year: "2011",
    title: "Swine Flu Epidemic Response",
    body: "Appreciated by Hon. Health Minister, Govt. of Gujarat",
    desc: "Acknowledged for effective control of the Swine Flu epidemic; also lauded by the Union Health Minister.",
  },
  {
    year: "2009–12",
    title: "Infection Control Research — IIM Ahmedabad",
    body: "IIM Ahmedabad with University of Aberdeen, UK",
    desc: "Recognised for excellent assistance in the 'Infection Control Intervention Study in Maternity Wards' research project.",
  },
  {
    year: "2010",
    title: "National AIDS Control Program",
    body: "Establishment of HIV Testing in all PHCs of Ahmedabad",
    desc: "Ahmedabad became the first district in Gujarat to provide HIV testing across all primary health centres.",
  },
];

export const services = [
  "NABH Accreditation Support & Quality Management",
  "Hospital & Healthcare Administration",
  "Medical College Establishment (Greenfield / Brownfield)",
  "Hospital Branding, Marketing & Business Development",
  "Capacity Building & Healthcare HR Development",
  "Public Health, CSR & NGO Fundraising Support",
  "MCI / NMC Inspection Management",
  "Infection Control & Patient Safety Systems",
];
